import { useMemo } from 'react';
import { useServiceLogo } from '~/hooks/use-service-logo';
import { ServiceApiModel } from '~/lib/api/rulemanager/types';
import { SmartSendProvider } from '~/lib/consts/providers';

export const swaps = {
  myhermes: 'hermes',
  dhlparcel: 'dhl',
  'ups-access-point': 'ups'
};

const useProcessedServices = (services: ServiceApiModel[]) => {
  const { getSrc } = useServiceLogo();

  // Process so the various hermes courier db records appear as one courier.
  const processedServices = useMemo(
    () =>
      services.map((s) => ({
        ...s,
        courierSlug: swaps[s.courierSlug] || s.courierSlug,
        serviceLogo: getSrc({ Provider: SmartSendProvider, Id: s.slug }),
        courierLogo: getSrc({ Provider: SmartSendProvider, Id: s.courierSlug })
      })),
    [services, getSrc]
  );

  // Limit to unique couriers
  const processedCouriers = useMemo(
    () =>
      processedServices
        .filter((option, index, self) => self.findIndex((item) => item.courierSlug === option.courierSlug) === index)
        .map((x) => ({
          courierSlug: x.courierSlug,
          courier: x.name,
          slugs: processedServices.filter((s) => s.courierSlug === x.courierSlug).map((s) => s.slug),
          serviceLogo: x.serviceLogo,
          courierLogo: x.courierLogo
        }))
        .sort((a, b) => a.courier.localeCompare(b.courier)),
    [processedServices]
  );

  return { processedServices, processedCouriers } as const;
};

export default useProcessedServices;
